// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3DnKI","balanceDisclaimer":"posDashboard_balanceDisclaimer__3sbOA"};